// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"559":"edccc15c","877":"4c02a81f","964":"4ee3f23f","973":"07696798"}[chunkId] + ".chunk.css";
};